module.exports = __webpack_public_path__ + "img/airSwing5.32b0121c.svg";